<template>
    <div class="container v-content-container">
    <!-- "PLEASE WAIT" layer, displayed as long as selected bookings will be confirmed/cancelled -->
    <div class="modal fade" id="pleaseWait">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><strong><i class="text-primary fa fa-fw fa-lg fa-info-circle"></i></strong> Hinweis</h4>
                </div>
                <div class="modal-body" id="pleaseWaitContent">
                </div>
                <div class="modal-footer">
                    <i class="text-primary fa fa-fw fa-lg fa-map-marker fa-spin"></i> Diese Seite aktualisiert sich nach Beendigung der Aktion von selbst.
                </div>
            </div>
        </div>
    </div>
    <!-- BEGIN Cancel booking -->
    <div class="modal fade" id="booking-cancel-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h3 class="modal-title" id="myModalLabel">
                        <i class="fa fa-fw fa-lg fa-times text-warning"></i> <span id="cancel-modal-label"> Buchung stornieren </span>
                    </h3>
                </div>

                <div class="modal-body" id="cancel-modal-body">
                    Diese Buchung wirklich stornieren?
                </div>

                <div class="modal-footer">
                    <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Abbrechen</button>
                    <a id="booking-cancel-link" class="btn btn-warning" href="" >Jetzt stornieren</a>
                </div>
            </div>
        </div>
    </div>
    <!-- END Cancel booking -->
    <!-- BEGIN Venues menu -->
    <div class="row">
        <div class="col-xs-12 tooltip-wrapper">
            <h1>
                <i class="fa fa-fw fa-lg fa-map-marker"> </i> Venues
                <a href="/venues/groupbookings/" class="btn btn-v-lightgreen-white pull-right" data-toggle="tooltip" data-placement="top" title="Buchungsgruppen">
                    <i class="fa fa-fw fa-lg fa-list-alt"></i>
                </a>
                <a id="button-calendar" class="btn btn-v-lightgreen-white pull-right hidden-xs" href="/venues/scheduler/" data-toggle="tooltip" data-placement="top" title="Kalender">
                    <i class="fa fa-fw fa-lg fa-calendar"></i>
                </a>
                <a class="btn btn-v-lightgreen-white pull-right hidden-xs" href="/venues/" data-toggle="tooltip" data-placement="top" title="Tabellenansicht">
                    <i class="fa fa-fw fa-lg fa-list"></i>
                </a>
                <a href="#" class="btn btn-v-lightgreen-white pull-right" data-toggle="tooltip" data-placement="top" target="_blank" id="pdfCalendar" title="Tages-/Wochenplan PDF">
                    <i class="fa fa-fw fa-lg fa-file-pdf-o"></i>
                </a>
                <a id="button-new-booking" class="btn btn-v-lightgreen-white pull-right" disabled href="">
                    <i class="fa fa-lg fa-plus"></i>
                </a>
                <!-- <a id="button-new-booking" class="btn btn-v-lightgreen-white pull-right" href="<?= (isset($this->selectedVenueId) ? '/venues/' . $this->selectedVenueId . '/booking/' : '/venues/booking/new/') ?>" data-toggle="tooltip" data-placement="top" title="Neue Buchung">
                    <i class="fa fa-lg fa-plus"></i>
                </a>            -->
                <select id="venue-select" class="form-control venue-select pull-right" style="margin-right: 15px;">
                    <option value="">Alle</option>
                        <optgroup label="hello">
                            <option value="1"/>
                        </optgroup>
                </select>
            </h1>
        </div>
    </div>
    <!-- END Venues menu -->

    <!-- BEGIN Group booking -->
    <div class="modal fade" id="booking-groupbooking-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h3 class="modal-title" id="myModalLabel">
                        <i class="fa fa-fw fa-lg fa-list-alt text-primary"></i> <span id="cancel-modal-label"><?= $this->customizer->getSingular('groupbooking') ?> auswählen</span>
                    </h3>
                </div>

                <div class="modal-body" id="cancel-modal-body">
                    <div class="v-form v-form-borderless">
                        <fieldset>
                            <div class="row" id="preselectedCustomer">
                                <section class="col col-10">
                                    <label id="select_groupbooking_label" class="label">&nbsp;</label>
                                    <label class="input">
                                        <input type="text" id="select_groupbooking" name="customer_id" style="width: 100% !important;">
                                        <input type="hidden" id="customer_id">
                                        <input type="hidden" id="booking_id">
                                        <input type="hidden" id="subscription_id">
                                        <i></i>
                                    </label>
                                </section>
                                <section class="col col-2 change-customer-booking">
                                    <label class="label">&nbsp;</label>
                                    <button id="add-groupbooking-group" class="btn btn-primary v-form-button v-white" data-placement="top" data-toggle="tooltip"
                                            title="<?= $this->customizer->declineWord('groupbooking', 'Neuen', 'Neue', 'Neues') . ' ' . $this->customizer->getSingular('groupbooking') ?> anlegen">
                                        <i class="fa fa-lg fa-plus"></i>
                                    </button>
                                </section>
                            </div>
                        </fieldset>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Abbrechen</button>
                    <button id="groupbooking-assign-button" class="btn btn-primary">Hinzufügen</button>
                </div>
            </div>
        </div>
    </div>
    <!-- END Group booking -->

    <!-- BEGIN Group booking add -->
    <div class="modal fade" id="booking-groupbooking-add-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h3 class="modal-title" id="myModalLabel">
                        <i class="fa fa-fw fa-lg fa-list-alt text-primary"></i>
                        <span id="cancel-modal-label">Neue</span>
                    </h3>
                </div>

                <div class="modal-body" id="cancel-modal-body">
                    <div class="v-form v-form-borderless">
                        <fieldset>
                            <div class="row">
                                <section class="col col-12">
                                    <label class="label">Name</label>
                                    <label class="input">
                                        <input type="text" id="add-groupbooking-name" style="width: 100% !important;">
                                        <i></i>
                                    </label>
                                </section>
                            </div>
                            <div class="row">
                                <section class="col col-12">
                                    <label class="label">Beschreibung</label>
                                    <label class="textarea">
                                        <textarea rows="4" id="add-groupbooking-notes"></textarea>
                                    </label>
                                </section>
                            </div>
                        </fieldset>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Abbrechen</button>
                    <button id="groupbooking-add-button" class="btn btn-primary">Hinzufügen</button>
                </div>
            </div>
        </div>
    </div>
    <!-- END Group booking add -->

    <div class="row tooltip-wrapper hidden-xs">
        <div class="col-xs-12">
            <div id="action-dropdown" class="btn-group" style="margin-left: 5px;">
                <button type="button" class="btn btn-primary dropdown-toggle hidden-xs" data-toggle="dropdown">
                    <i class="fa fa-refresh"></i> &nbsp; Aktionen &nbsp;<span class="caret"></span>
                </button>
                <ul class="dropdown-menu" role="menu">
                    <li><a id="confirm-checked-bookings" href="#"><i class="text-primary fa fa-fw fa-lg fa-check"></i>&nbsp; Ausgewählte Termine bestätigen</a></li>
                    <li><a id="cancel-checked-bookings" href="#"><i class="text-primary fa fa-fw fa-lg fa-times"></i>&nbsp; Ausgewählte Termine stornieren</a></li>
                </ul>
                <form id="export-form" action="/venues/export/" method="POST" style="display: inline-block;">
                    <button id="exporting" class="btn btn-primary dropdown-toggle hidden-xs" data-toggle="dropdown" >
                        <i class="fa fa-refresh"></i> Export <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" role="menu">
                        <li><a id="pdf-export" href="#"><i class="text-primary fa fa-fw fa-lg fa-check"></i>&nbsp; PDF exportieren</a></li>
                        <li><a id="csv-export" href="#"><i class="text-primary fa fa-fw fa-lg fa-list"></i>&nbsp; CSV exportieren</a></li>
                    </ul>
                </form>
            </div>
        </div>
    </div>

    <div class="row hidden-xs">
        <div class="col-xs-12 text-center tooltip-wrapper" style="vertical-align: top !important;">
            <form class="form-inline" role="form">
                <div class="form-group" id="table-venues-search"> &nbsp;</div>
                <button class="btn btn-success form-control" data-toggle="modal" data-target="#venue-search-filter" rel="tooltip" title="Weitere Suchfilter" type="button">
                    <i class="fa fa-fw fa-lg fa-search-plus"></i>
                </button>
            </form>
        </div>
    </div>

    <div class="modal fade" id="venue-search-filter" tabindex="-1" role="dialog" aria-labelledby="venueSearchFilter" aria-hidden="true">
        <div class="modal-dialog">
            <form action="" method="POST">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        <h3 class="modal-title" id="venue-search-filter-label"><i class="fa fa-fw fa-lg fa-search-plus text-primary"></i> Erweiterte Suche</h3>
                    </div>
                    <div class="modal-body">

                        <div class="row well">
                            <div class="col-xs-6">
                                <label class="input">Start
                                    <input type="text" class="form-control" name="start" id="start" placeholder="Von" value="<?= $this->preselectedFromDate ?>">
                                </label>
                            </div>
                            <div class="col-xs-6">
                                <label id="finishLabel" class="input">Ende
                                    <input type="text" class="form-control" name="finish" id="finish" placeholder="Bis">
                                </label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-6" style="padding-left: 35px;">
                                <label class="input">Kundentyp
                                    <select id="customer-type-select"  class="form-control">
                                        <option value="">Alle</option>
                                        <?php foreach (\helper\Registry::get()->customerTypeNames as $key => $type): ?>
                                            <option value="<?= $key ?>"><?= $type['singular'] ?></option>
                                        <?php endforeach; ?>
                                    </select>
                                </label>
                            </div>
                            <div class="col-xs-6">
                                <label class="input">Kundengruppe
                                    <select id="customer-group-select"  class="form-control">
                                        <option value="">Alle</option>
                                        <option value="1">john group</option>
                                    </select>
                                </label>
                            </div>
                        </div>

                        <div class="row"><div class="col-xs-12">&nbsp;</div></div>

                        <div class="row well">
                            <div class="col-xs-6">
                                <label class="input">Buchungsstatus
                                    <select id="booking-status" class="select2" style="width: 100%" multiple="multiple">
                                        <option value="success">Confirmed</option>
                                    </select>
                                </label>
                            </div>
                            <div class="col-xs-6">
                                <label class="input">Ursprung der Buchung
                                    <select id="booking-origin" class="form-control">
                                        <option value="">Alle</option>
                                        <option value="internal">Interne Eingabe</option>
                                        <option value="widget">Buchungswidget</option>
                                        <option value="venuzle">Venuzle Sportportal</option>
                                    </select>
                                </label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-xs-6" style="padding-left: 25px;">
                                <div class="v-form" style="border: 0 !important; box-shadow: none !important;">
                                    <fieldset>
                                            <label class="checkbox">
                                                <input id="groupSubscripitions" type="checkbox" value="true" name="group_subscriptions" <?= (isset($this->groupSubscriptions) && $this->groupSubscriptions ? 'checked' : '') ?>><i></i> Abos zusammenfassen
                                            </label>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="col col-xs-6">
                                <label class="input">Booking type
                                    <select id="booking-type-select" class="form-control">
                                        <option value="">Alle</option>
                                        <option value="subscription">Nur Abo-Termine</option>
                                        <option value="single">Nur Einzeltermine</option>
                                    </select><i></i>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button id="reset-filter" type="button" data-dismiss="modal" class="btn btn-default"><i class="fa fa-fw fa-undo"></i> Zurücksetzen</button>
                        <button id="submit-filter" type="button" data-dismiss="modal" class="btn btn-primary"><i class="fa fa-fw fa-search"></i> Übernehmen</button>
                    </div>

                </div>
            </form>
        </div>
    </div>

    <div class="row tooltip-wrapper popup-wrapper">
        <div class="col-xs-12">
            <div class="v-datatable table-responsive">
                <div id="venues-table">
                    <form id="table-form" action="#" method="POST">
                        <table class="table table-striped table-bordered table-hover" id="table-venues">
                            <thead>
                                <tr>
                                    <th class="table-checkbox text-center v-form v-form-disable">
                                        <label class="hidden-xs checkbox"><input type="checkbox" class="group-checkable" data-set="#table-venues .checkboxes"><i></i></label>
                                    </th>
                                    <th class="table-venues-venue">
                                        Venue
                                    </th>
                                    <th class="text-center table-venues-bookings">
                                        Buchung
                                    </th>
                                    <th>
                                        Kunde
                                    </th>
                                    <th class="table-venues-price text-center">
                                        $
                                    </th>
                                    <th class="text-center table-venues-status">
                                        Status
                                    </th>
                                    <th class="table-venues-actions text-center">
                                        Aktionen
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

export default {
  name: 'home'
}
</script>
